import React from 'react';

import { useYearSelectPresenter } from './YearSelect.presenter';
import * as S from './YearSelect.styles';

export const YearSelect = (props) => {
  const presenter = useYearSelectPresenter();

  return (
    <S.YearSelect
      {...props}
      disabled={presenter.disabled}
      error={presenter.error}
      list={presenter.list}
      value={presenter.value}
      onChange={presenter.onChange}
    />
  );
};
